import React, { useState, useEffect, useCallback } from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

import ContentfulLongText from "../ContentfulLongText"
import Button from "../Button"
import { SearchIcon } from "../SearchIcon"
import { Container } from "../Container"

import "./index.css"

export const  BlogListStack = ({ data, blogTitle, hasCatFilter=false, dataCat='' }) => {
    const urlParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
    const catParam = urlParams.get('cat');
    const [blogPosts, setBlogPosts] = useState(data);
    const [isCategory, setCategory] = useState('all')
    const initialPostsToShow = 12
    const postsPerLoad = 3;
    const [visiblePosts, setVisiblePosts] = useState(initialPostsToShow);
    const [searchQuery, setSearchQuery] = useState("")

    const handleLoadMore = () => {
        setVisiblePosts(visiblePosts + postsPerLoad);
    };

    const handleCat = useCallback((e) => {
        let filteredPosts = [];
    
        if (e === 'All') {
        setCategory('All');
        setVisiblePosts(initialPostsToShow);
        setBlogPosts(data);
        } else {
        filteredPosts = data.filter(item => {
            if (Array.isArray(item.categories) && item.categories.length > 0) {
            return item.categories.some(category => category.title === e);
            } else if (item.categories && item.categories.title === e) {
            return true;
            }
            return false;
        });
    
        setCategory(e);
        setVisiblePosts(initialPostsToShow);
        setBlogPosts(filteredPosts);
        }
    }, [data]);

    const filteredBlogs = data.filter(post =>
        post.title.toLowerCase().includes(searchQuery.toLowerCase())
    )

    const handleSearchInputChange = event => {
        setSearchQuery(event.target.value)
    }

    useEffect(() => {
        if (catParam) {
        handleCat(catParam);
        }
    }, [handleCat, catParam]);

    let postContent = searchQuery.length > 0 ? filteredBlogs : blogPosts;

    return (
        <div className="blog-wrap page--light page-banner--hidden">
            <Container>
                <div className="blog-head">
                    <div className="mb-30">
                        <h1 className="uppercase">{isCategory !== 'all' ? `${isCategory} `:''}{blogTitle}</h1>
                        <div className="flex align-center blog-heaad__search">
                            <div style={{ height: '41px', backgroundColor: '#eee' }}>
                                <SearchIcon/>
                            </div>
                            <input
                                type="text"
                                placeholder="Search by blog title"
                                value={searchQuery}
                                onChange={handleSearchInputChange}
                                style={{ width: '100%' }}
                            />
                        </div>
                    </div>
                    {(hasCatFilter && dataCat !== '') && (
                        <div className="flex wrap py-20 blog-head-cat">
                            <button onClick={() => handleCat('All')} className={`text--dark decoration-none bold ${isCategory === 'all' && 'active'}`}>All</button>
                            {dataCat.map((cat, index) => (
                            <button id={cat.title} onClick={() => handleCat(cat.title)} key={index} className={`text--dark decoration-none bold ${isCategory === cat.title && 'active'}`}>{cat.title}</button>
                            ))}
                        </div>
                    )}
                </div>
                {postContent.length === 0 ? (
                <div className="bold no-posts">No Posts Available</div>
                ):(
                <>
                    <div className="grid col-3 gap-20 col-2-md col-1-xs">
                    {postContent.slice(0, visiblePosts).map((post, index) => {
                        // let excerptContent = post.blogBodyContent === null ? post.excerpt.raw : (post.excerptContentOptions === null || post.excerptContentOptions === 'Default: Body Content') ? post.blogBodyContent[0].textContent.textContent : (post.excerptContentOptions === 'Intro Content' && post.introTextStyling !== null) ? post.introTextStyling.content.content : post.blogBodyContent[0].textContent.textContent;
                        let excerptContent = post.blogBodyContent && post.blogBodyContent.length > 0 && post.blogBodyContent[0].textContent
                            ? (post.excerptContentOptions === null || post.excerptContentOptions === 'Default: Body Content') 
                                ? post.blogBodyContent[0].textContent.textContent 
                                : (post.excerptContentOptions === 'Intro Content' && post.introTextStyling !== null) 
                                ? post.introTextStyling.content.content 
                                : post.blogBodyContent[0].textContent.textContent
                            : post.excerpt.raw;

                        return (
                        <div key={index}>
                            {post.thumbnailImage && (
                                <a href={`/${post.parentCategory.slugId}/${encodeURIComponent(post.blogPostUrlSlug)}`} className="image-link-wrap relative block overflow-hidden" cat={post.categories.map(cat => cat.title).join(', ')}>
                                    <GatsbyImage
                                    image={getImage(post.thumbnailImage)}
                                    alt={`${post.title} thumbnail`}
                                    className="absolute h-full"
                                    />
                                </a>
                            )}
                            <div className="blog-meta">
                            <span className="blog-meta-left">
                            {post.categories !== null ? (
                                <>{post.categories.map((item, index) => (
                                <React.Fragment key={index}>
                                    {item.title}
                                    {index < post.categories.length - 1 && ', '}
                                </React.Fragment>
                                ))}</>
                            ) : null}
                            </span>
                            <span className="blog-meta-right">{post.publishDate.split("T")[0]}</span>
                            </div>
                            <Link to={`/${post.parentCategory.slugId}/${encodeURIComponent(post.blogPostUrlSlug)}`} className="decoration-none">
                            <h3 className="bold text-secondary font-secondary my-10">{post.title}</h3>
                            </Link>
                            <div className="blog-excerpt">
                                {post.blogBodyContent !== null ? <ContentfulLongText longTextContent={excerptContent} hasLimitChar={true} classNameProp={'blog-thumbnail'} />:documentToReactComponents(JSON.parse(excerptContent))}
                                
                            </div>
                        </div>
                        )
                    })}
                    </div>
                    {visiblePosts < postContent.length && <Button handleLoadMore={handleLoadMore} />}
                </>
                )}
            </Container>
        </div>
    )
}